import React from 'react';
import { StyleProp, View, ViewStyle, } from 'react-native';

/*   ====================================================================   */

interface ILED
{
bindEvent : (onEvent    : (() => void), 
             bSubscribe : boolean) => void;

getCxtState : () => boolean;

onPress? : () => void;

style: StyleProp<ViewStyle>;
}

/*   ====================================================================   */

interface ILEDState
   {
   oCxtState : boolean
   }

/*   ====================================================================   */

export default class LED extends React.Component<ILED>
   {
   private iCount : number = 0;

   UpdateData()
   {
   if (++this.iCount > 3)
      {
      this.iCount   = 0;
      let oCxtState = this.props.getCxtState();

      if (oCxtState != this.state.oCxtState)
         this.setState({oCxtState:oCxtState});
      }
   }

   /*   ------------------------------------------------------------------   */

   constructor(props)
   {
   super(props);
   this.UpdateData  = this.UpdateData.bind(this);
   this.state       = {oCxtState:this.props.getCxtState()}
   }

   /*   ------------------------------------------------------------------   */

   componentDidMount() 
   {
   this.props.bindEvent(this.UpdateData, true);
   }

   /*   ------------------------------------------------------------------   */

   componentWillUnmount() 
   {
   this.props.bindEvent(this.UpdateData, false);
   }

   /*   ------------------------------------------------------------------   */

   state : ILEDState = {oCxtState: false}

   /*   ------------------------------------------------------------------   */

   render() 
   {
   return (
         // <View style={{height:'100%', justifyContent:'center'}}>
         <View style={[this.props.style, {
                            //borderWidth:0, borderColor:'limegreen',
                            backgroundColor:this.state.oCxtState? '#03AC13' : 'red'}] } />
         //  </View>
          );
   }
}